'use client';
import React from 'react';
import DriveXNav from './components/DriveXNav';
import DriveXHero from './components/DriveXHero';
import DriveXPainPoints from './components/DriveXPainPoints';
import DriveXFeatures from './components/DriveXFeatures';
import DriveXAIDemo from './components/DriveXAIDemo';
import DriveXPricing from './components/DriveXPricing';
import DriveXTestimonials from './components/DriveXTestimonials';
import DriveXFinalCTA from './components/DriveXFinalCTA';
import DriveXFooter from './components/DriveXFooter';
import DriveXFloating from './components/DriveXFloating';

export default function DriveXPage() {
  return (
    <div className="dx-font" style={{ background: '#0A0A0A', overflowX: 'hidden' }}>
      <DriveXNav />
      <DriveXHero />
      <DriveXPainPoints />
      <DriveXFeatures />
      <DriveXAIDemo />
      <DriveXPricing />
      <DriveXTestimonials />
      <DriveXFinalCTA />
      <DriveXFooter />
      <DriveXFloating />
    </div>
  );
}
